import { render, staticRenderFns } from "./m-editSelection.vue?vue&type=template&id=2a3b0136&"
import script from "./m-editSelection.vue?vue&type=script&lang=js&"
export * from "./m-editSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports